define('collections/welcome_messages',['require','collections/base','models/welcome_message'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/welcome_message");

    return BaseCollection.extend({
        model: Model,
        url: 'welcome-messages.json',

        fetch: function() {
            // Do nothing, this collection will be initialize with static data
        }
    });
});

